// utils
import isValidObjectID from "../../../../utils/isValidObjectID";

export const isUsersLink = (link: string): boolean => {
	const linkParts = link.split("/");
	return !!(linkParts[1] === "user" && isValidObjectID(linkParts[2]));
};

export const getEmployeeIdFromLink = (link: string, index = 0): string => {
	let linkParts = link.split("/user/");
	linkParts = linkParts[1].split("/");
	return linkParts[index];
};

// job title can be a string or an array of strings
export const formatJobTitle = (jobTitle: string | string[]): string => {
	if (Array.isArray(jobTitle)) {
		return jobTitle.join(", ");
	}
	return jobTitle;
};

type FieldToCheck = {
	name: string;
	lookup: string;
};

type CompanyField = {
	name: string;
	tags: string[];
	type: string;
	visibleTo: string[];
};

/**
 * Checks if fields are visible based on company field settings and user permissions.
 * @param fieldsToCheckVisibility - Array of fields to check visibility for
 * @param companyFields - Company field configurations with visibility settings
 * @param userPermissions - Array of user permission roles (e.g., "all", "self", "admin", "manager")
 * @returns Object mapping field names to boolean visibility
 */
export const areFieldsVisible = (
	fieldsToCheckVisibility: FieldToCheck[],
	companyFields: CompanyField[] = [],
	userPermissions: string[]
): Record<string, boolean> => {
	const result: Record<string, boolean> = {};
	fieldsToCheckVisibility.forEach((fieldItem) => {
		const foundItem = companyFields?.find((field) => field?.name === fieldItem.lookup);
		if (foundItem) {
			const canView = foundItem?.visibleTo?.some((role) => userPermissions.includes(role));
			result[fieldItem.name] = canView;
		} else {
			result[fieldItem.name] = false;
		}
	});
	return result;
};
